export default "__VITE_ASSET__DAJ5SxxW__"